const OfferLineBreakdown = {
  paid_and_free: '{{paidQuantity}} × {{price}} maksettu · {{freeQuantity}} × ilmainen',
  all_free: '{{freeQuantity}} × ilmainen',
};

export default OfferLineBreakdown;
